<template>
  <div>

    <validation-provider
        v-slot="validationContext"
        name="Link Başlığı"
        rules="required"
      >
        <b-form-group
          label="Link Başlığı"
          label-for="campaign_name"
        >
          <b-form-input
            id="campaign_name"
            v-model="localValue.campaign_name"
            :state="getValidationState(validationContext)"
            @input="emitUpdate"
            trim
          />
          <b-form-invalid-feedback>
            {{ validationContext.errors[0] }}
          </b-form-invalid-feedback>
        </b-form-group>
      </validation-provider>
    
    <!-- Grup Seçimi -->
    <!-- <b-form-group label="Email (Opsiyonel)" label-for="group_id">
      <v-select
        v-model="localValue.group_id"
        :options="groupOptions"
        :reduce="opt => opt.id"
        label="campaign_name"
        placeholder="Grup seçin..."
        @input="emitUpdate"
      />
    </b-form-group> -->
  </div>
</template>

<script>
import {
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
  BButton,
  BFormInvalidFeedback
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import axiosIns from '@/axios'
import { ValidationProvider } from 'vee-validate'

export default {
  name: 'EmailShareForm',
  components: {
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    BButton,
    BFormInvalidFeedback,
    vSelect,
    ValidationProvider
  },
  props: {
    linkData: { type: Object, required: true },
    editingLink: { type: Object, default: null },
    startDate: { type: Object, required: true },
    endDate: { type: Object, required: true },
    platformOptions: { type: Array }
  },
  data() {
    return {
      localValue: { ...this.linkData },
      shortCodeEditMode: false,
      groupOptions: []
    }
  },
  watch: {
    linkData: {
      handler(newVal) {
        this.localValue = { ...newVal }
      },
      deep: true
    },
    'localValue.group_id': function () {
      this.emitUpdate()
    },
    'localValue.platform_id': function (newPlatform) {
      if (!newPlatform) return
      const selectedPlatform = this.platformOptions.find(p => p.value === newPlatform)
      if (selectedPlatform) {
        this.localValue.short_code = selectedPlatform.short_code || 'test'
        this.linkData.short_code = selectedPlatform.short_code || 'test'
      }
    }
  },
  mounted() {
    this.fetchGroups()
  },
  methods: {
    async fetchGroups() {
      try {
        const res = await axiosIns.get('/link/category', { params: { type: 5 } })
        this.groupOptions = res.data.data || []
      } catch (err) {
        console.error('Gruplar yüklenemedi:', err)
      }
    },
    emitUpdate() {
      this.$emit('update', { ...this.localValue })
    },
    getValidationState(context) {
      if (context) return context.validated ? !context.invalid : null
      return null
    }
  }
}
</script>
